import { AxiosResponse } from "axios";
import { APIClient } from "./axiosClient";
import { IExceptKeyword, IMonitor, IMonitorClick, IMonitorIP, IMonitorSystemUuidConfigs, IMonitorUser, IMonitorClickSetting } from "./types/_monitor";
import { PaginationResponse, ResponseData } from "./types/_public";
const api = new APIClient();

const path = '/monitors';
const monitorApi = {
  monitors(params: any): Promise<AxiosResponse<ResponseData<IMonitor[]> & PaginationResponse, any>> {
    const url = `${path}/scripts`
    return api.get(url, params)
  },
  putStatusAlarmMonitor(id: string | number, dataForm: any): Promise<AxiosResponse<ResponseData<IMonitor>, any>> {
    const url = `${path}/scripts/${id}`;
    return api.put(url, dataForm)
  },
  monitorClicks(params: any): Promise<AxiosResponse<ResponseData<IMonitorClick[]> & PaginationResponse, any>> {
    const url = `${path}/click-alarms`
    return api.get(url, params)
  },
  monitorUsers(params: any): Promise<AxiosResponse<ResponseData<IMonitorUser[]> & PaginationResponse, any>> {
    const url = `${path}/users`
    return api.get(url, params)
  },
  putStatusAlarmMonitorClick(id: string | number, dataForm: any): Promise<AxiosResponse<ResponseData<IMonitorClick>, any>> {
    const url = `${path}/click-alarms/${id}`;
    return api.put(url, dataForm);
  },
  monitorClickSettings(params: any): Promise<AxiosResponse<ResponseData<IMonitorClick[]> & PaginationResponse, any>> {
    const url = `${path}/click-settings`
    return api.get(url, params)
  },
  getMonitorClickSetting(params: any = {}): Promise<AxiosResponse<ResponseData<IMonitorClickSetting>, any>> {
    const url = `${path}/click-settings`;
    return api.get(url, params);
  },
  postMonitorClickSetting(dataForm: any): Promise<AxiosResponse<ResponseData<IMonitorClick>, any>> {
    const url = `${path}/click-settings`;
    return api.post(url, dataForm);
  },
  putMonitorClickSetting(id: string | number, dataForm: any): Promise<AxiosResponse<ResponseData<IMonitorClick>, any>> {
    const url = `${path}/click-settings/${id}`;
    return api.put(url, dataForm);
  },
  deleteMonitorClickSetting(id: string | number, dataForm: any): Promise<AxiosResponse<ResponseData<IMonitorClick>, any>> {
    const url = `${path}/click-settings/${id}`;
    return api.delete(url, dataForm);
  },
  getMonitorUser(id: string | number, params: any = {}): Promise<AxiosResponse<ResponseData<IMonitorUser>, any>> {
    const url = `${path}/users/${id}`;
    return api.get(url, params)
  },
  postMonitorUser(dataForm: any): Promise<AxiosResponse<ResponseData<IMonitorUser>, any>> {
    const url = `${path}/users`;
    return api.post(url, dataForm)
  },
  putMonitorUser(id: string | number, dataForm: any): Promise<AxiosResponse<ResponseData<IMonitorUser>, any>> {
    const url = `${path}/users/${id}`;
    return api.put(url, dataForm)
  },
  deleteMonitorUser(id: string | number, dataForm: any): Promise<AxiosResponse<ResponseData<IMonitorUser>, any>> {
    const url = `${path}/users/${id}`;
    return api.delete(url, dataForm)
  },
  monitorExceptKeywords(params: any): Promise<AxiosResponse<IExceptKeyword[]>> {
    const url = `/keywords/excepts`
    return api.get(url, params)
  },
  postExceptKeyword(dataForm: any): Promise<AxiosResponse<IExceptKeyword[]>> {
    const url = `/keywords/excepts`;
    return api.post(url, dataForm)
  },
  getMonitorSystemUuidConfigs(params: any = {}): Promise<AxiosResponse<ResponseData<IMonitorSystemUuidConfigs>, any>> {
    const url = `system/uuid-configs`;
    return api.get(url, params)
  },

  getMonitorIP(params: any = {}): Promise<AxiosResponse<ResponseData<IMonitorIP[]> & PaginationResponse, any>> {
    const url = `/trackings/ad-logs/abusive-ip-filtering`
    return api.get(url, params)
  },
  getMonitorIPDetail(ip: string | number): Promise<AxiosResponse<ResponseData<IMonitorIP>, any>> {
    const url = `/trackings/ad-logs/abusive-ip-filtering/${ip}`;
    return api.get(url)
  },
}
export default monitorApi
